import i18 from 'i18next';
import { PAGES } from '../pages';

export const jointAccountMenu = [
  {
    title: i18.t('createAccount'),
    checked: true,
  },
  {
    title: i18.t('secureAccount'),
    path: PAGES.SECURE_ACCOUNT,
    nextPath: PAGES.SECURE_NAME,
    previousPath: PAGES.BASE,
    items: [
      {
        title: i18.t('name'),
        path: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_DOB,
        previousPath: PAGES.SECURE_ACCOUNT,
      },
      {
        title: i18.t('dob'),
        path: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY,
        previousPath: PAGES.SECURE_NAME,
      },
      {
        title: i18.t('identityVerification'),
        path: PAGES.SECURE_IDENTITY,
        nextPath: PAGES.SECURE_IDENTITY_SSN,
        previousPath: PAGES.SECURE_DOB,
        skipPath: PAGES.SECURE_PHONE_NUMBER,
        items: [
          {
            path: PAGES.SECURE_IDENTITY_SSN,
            nextPath: PAGES.SECURE_PHONE_NUMBER,
            previousPath: PAGES.SECURE_IDENTITY,
          },
        ],
      },
      {
        title: i18.t('phoneNumber'),
        path: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_IDENTITY_SSN,
        nextPath: PAGES.SECURE_SECONDARY,
        preSkipPath: PAGES.SECURE_IDENTITY,
      },
      {
        title: i18.t('secondaryOwner'),
        path: PAGES.SECURE_SECONDARY,
        nextPath: PAGES.SECURE_SECONDARY_DOB,
        previousPath: PAGES.SECURE_PHONE_NUMBER,
        preSkipPath: PAGES.SECURE_IDENTITY,
        items: [
          {
            path: PAGES.SECURE_SECONDARY_DOB,
            nextPath: PAGES.SECURE_SECONDARY_IDENTITY,
            previousPath: PAGES.SECURE_SECONDARY,
          },
          {
            path: PAGES.SECURE_SECONDARY_IDENTITY,
            nextPath: PAGES.SECURE_SECONDARY_SSN,
            previousPath: PAGES.SECURE_SECONDARY_DOB,
            skipPath: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
            dependentSkipPath: PAGES.SECURE_SECONDARY_IRS,
          },
          {
            path: PAGES.SECURE_SECONDARY_SSN,
            nextPath: PAGES.SECURE_SECONDARY_IRS,
            skipPath: PAGES.SECURE_PHONE_NUMBER,
            previousPath: PAGES.SECURE_SECONDARY_IDENTITY,
          },
          {
            path: PAGES.SECURE_SECONDARY_IRS,
            nextPath: PAGES.SECURE_SECONDARY_IRS_SUBJECT,
            previousPath: PAGES.SECURE_SECONDARY_SSN,
            skipPath: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
            preSkipPath: PAGES.SECURE_SECONDARY_IDENTITY,
          },
          {
            path: PAGES.SECURE_SECONDARY_IRS_SUBJECT,
            nextPath: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
            previousPath: PAGES.SECURE_SECONDARY_IRS,
          },
          {
            path: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
            previousPath: PAGES.SECURE_SECONDARY_IRS_SUBJECT,
            preSkipPath: PAGES.SECURE_SECONDARY_IDENTITY,
            nextPath: PAGES.ADDRESS,
          },
        ],
      },
    ],
  },
  {
    title: i18.t('address'),
    path: PAGES.ADDRESS,
    nextPath: PAGES.ADDRESS_ENTER,
    previousPath: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
    preSkipPath: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
    dependentSkipPath: PAGES.SECURE_SECONDARY_PHONE_NUMBER,
    items: [
      {
        path: PAGES.ADDRESS_ENTER,
        nextPath: PAGES.ADDRESS_SECONDARY,
        previousPath: PAGES.ADDRESS,
      },
      {
        path: PAGES.ADDRESS_SECONDARY,
        nextPath: PAGES.ADDRESS_SECONDARY_ENTER,
        previousPath: PAGES.ADDRESS_ENTER,
        skipPath: PAGES.ADDRESS_DONE,
      },
      {
        path: PAGES.ADDRESS_SECONDARY_ENTER,
        nextPath: PAGES.ADDRESS_DONE,
        previousPath: PAGES.ADDRESS_SECONDARY,
        skipPath: PAGES.ADDRESS_DONE,
      },
      {
        path: PAGES.ADDRESS_DONE,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        previousPath: PAGES.ADDRESS_SECONDARY_ENTER,
      },
    ],
  },
  {
    title: i18.t('fund'),
    path: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    nextPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
    previousPath: PAGES.ADDRESS_DONE,
    skipPath: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
    items: [
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.PLAID,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.WIRE,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CHECK,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT.CRYPTOCURRENCY,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
        nextPath: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
      },
      {
        path: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
        nextPath: PAGES.REVIEW,
        previousPath: PAGES.FUNDING.NORMAL_FUNDING.AMOUNT,
        preSkipPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
      },
    ],
  },
  {
    title: i18.t('review'),
    path: PAGES.REVIEW,
    nextPath: PAGES.AGREEMENT,
    previousPath: PAGES.FUNDING.NORMAL_FUNDING.JOINT_SURVIVOR,
    preSkipPath: PAGES.FUNDING.NORMAL_FUNDING.ACCOUNT,
    items: [
      {
        path: PAGES.AGREEMENT,
        nextPath: '/',
        previousPath: PAGES.REVIEW,
      },
    ],
  },
];
